import * as Sentry from "@sentry/react"

if (process.env.NODE_ENV === "production" && process.env.REACT_APP_SENTRY_RELEASE && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    environment: process.env.REACT_APP_SENTRY_ENV,
    sendDefaultPii: true,
    integrations: [
    ],
  })
}
